import {
  SANGAN,
  THUNDER_DRAGON,
  WITCH_OF_THE_BLACK_FOREST,
} from '@shared/index'
import { t } from '../i18n/t'

/** Title for a Deck search. The banner and the list use the same line. */
export function deckSearchPrompt(cardId: string): string {
  const id = Number(cardId)
  if (id === THUNDER_DRAGON) return t('duel.picker.thunderDragon')
  if (id === SANGAN) return t('duel.picker.sangan')
  if (id === WITCH_OF_THE_BLACK_FOREST) return t('duel.picker.witch')
  return t('duel.picker.searchDeck')
}
